import {
  fb, db, isJSON, indexOf, arrayUnion, sortItems,
  compareObject, uploadStorage
} from '@/components/common.js'

export default {
  signOut: ({commit}) => {
    commit('enqueueAsync')
    fb.auth().signOut()
      .then(() => {
        console.log('Sign-out successful.')
        commit('signOut')
        commit('enqueueRoute', {name: 'sign-in'})
      })
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  closeAccount: ({commit}) => {
    commit('enqueueAsync')
    const user = fb.auth().currentUser
    user.delete().then(() => {
      console.log('User deleted.')
      commit('signOut')
      alert('アカウントを削除しました。')
      commit('enqueueRoute', {name: 'sign-in'})
    })
      .catch(error => {
        console.error(error)
        alert('アカウントの削除に失敗しました。')
      })
      .finally(() => commit('dequeueAsync'))
  },

  updateUserProfile: ({commit, state}, user) => {
    const nickname = user.nickname || state.user.nickname || ''
    const birthday = user.birthday || state.user.birthday || ''
    if (user.image) {
      user.image.path = `users/${state.user.uid}/${state.user.uid}-${user.image.id}.jpg`
      uploadStorage(
        {full_path: user.image.path, source: user.image.source},
        {customMetadata: {uid: state.user.uid}}
      )
      commit('storeCacheImage', {fullPath: user.image.path, source: user.image.source})
    }
    const images = user.image ? [{id: 1, full_path: user.image.path}] : state.user.images;
    (async () => {
      commit('enqueueAsync')
      await db.doc('users/' + state.user.uid).update({
        images: images || [],
        nickname,
        modified: fb.firestore.FieldValue.serverTimestamp()
      })
      await db.doc('users/' + state.user.uid + '/private/1').update({
        birthday,
        modified: fb.firestore.FieldValue.serverTimestamp()
      })
      commit('storeUser', {
        ...state.user,
        nickname,
        birthday,
        images
      })
      commit('enqueueRoute', {name: 'user', params: {uid: state.user.uid}})
    })()
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  addPageToUser ({commit, state}, page) {
    const pageRef = db.doc('pages/' + page.id)
    const pages = [...state.user.pages || []]
    arrayUnion(pages, 'id', {
      pages_ref: pageRef,
      id: page.id,
      role: page.role,
      title: page.title || null,
      images: page.images || [],
      publish: page.publish || false,
      created: page.created,
      dates: page.dates
    })
    commit('enqueueAsync')
    db.doc('users/' + state.user.uid).update({
      pages,
      modified: fb.firestore.FieldValue.serverTimestamp()
    })
      .then(() => {
        console.log('update user.pages')
        commit('storeUser', {...state.user, pages})
      })
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  fetchUserWithPrivate ({commit, state}, user) {
    if (!user.uid) {
      return false
    }
    (async () => {
      if (!user.providerData.length) {
        commit('anonymousOn')
      }
      if (!state.signInAnonymous) {
        // 匿名ユーザ作成時はローディング表示しない
        commit('enqueueAsync')
      }
      const doc = await db.collection('users').doc(user.uid).get()
      let _public = {}
      if (doc.exists) {
        _public = doc.data()
      } else {
        _public = {uid: user.uid, nickname: user.displayName || ''}
        await db.doc('users/' + user.uid).set({
          ..._public,
          created: fb.firestore.FieldValue.serverTimestamp()
        })
        console.log('Created users')
      }
      const _private = {
        uid: user.uid,
        name: user.displayName,
        email: user.email,
        provider: user.providerData.length ? user.providerData[0].providerId : null,
        signed_in: new Date(user.metadata.a - 0),
        accessed: fb.firestore.FieldValue.serverTimestamp()
      }
      await db.doc('users/' + user.uid + '/private/1').set(_private, {merge: true})
      const docPrivate = await db.doc('users/' + user.uid + '/private/1').get()
      const privateData = docPrivate.data()

      /*
        * 匿名ユーザのデータとマージ
        */
      if (localStorage.wishlists || localStorage.histories) {
        const wishlists = isJSON(localStorage.wishlists) ? JSON.parse(localStorage.wishlists) : []
        const histories = isJSON(localStorage.histories) ? JSON.parse(localStorage.histories) : []
        const receipts = isJSON(localStorage.receipts) ? JSON.parse(localStorage.receipts) : []
        wishlists.forEach(page => {
          page.created = new Date(page.created.seconds ? page.created.seconds * 1000 : page.created)
          page.dates = page.dates.map(date => {
            return date ? new Date(date.date ? date.date.seconds * 1000 : date) : null
          })
          privateData.wishlists = privateData.wishlists || []
          arrayUnion(privateData.wishlists, 'page_id', page)
        })
        histories.forEach(page => {
          page.created = new Date(page.created.seconds ? page.created.seconds * 1000 : page.created)
          page.dates = page.dates.map(date => {
            return date ? new Date(date.date ? date.date.seconds * 1000 : date) : null
          })
          privateData.histories = privateData.histories || []
          arrayUnion(privateData.histories || [], 'id', page)
        })
        receipts.forEach(page => {
          page.created = new Date(page.created.seconds ? page.created.seconds * 1000 : page.created)
          page.dates = page.dates.map(date => {
            return date ? new Date(date.date ? date.date.seconds * 1000 : date) : null
          })
          privateData.receipts = privateData.receipts || []
          arrayUnion(privateData.receipts || [], 'id', page)
        })
        delete localStorage.wishlists
        delete localStorage.histories
        delete localStorage.receipts
        await db.doc('users/' + user.uid + '/private/1').update({
          ...privateData,
          modified: fb.firestore.FieldValue.serverTimestamp()
        })
      }

      commit('storeUser', {..._public, ...privateData})
      if (!_public.nickname && !state.anonymous) {
        commit('enqueueRoute', {name: 'account'})
      }
      commit('dequeueCallback')
    })()
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  fetchUser ({commit, state}, uid) {
    commit('enqueueAsync')
    db.collection('users').doc(uid).get()
      .then(doc => {
        if (doc.exists) {
          commit('storeUsers', doc.data())
        } else {
          if (location.href.match(/users/)) {
            commit('notFound', true)
          }
          throw new Error('users/' + uid + ' not found.')
        }
      })
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  createPage: ({commit, state}, page) => {
    function transaction (ref, page) {
      return db.runTransaction(t => {
        return t.get(ref).then(doc => {
          if (doc.exists) {
            throw new Error(page.id + ' is exists.')
          }
          t.set(ref, page)
          return true
        })
      })
    }
    page = {
      ...page,
      ...state.iniPage,
      members: [{
        role: 1,
        users_ref: db.doc('users/' + state.user.uid)
      }],
      operator_uids: [state.user.uid],
      editor_uids: [state.user.uid],
      admin_uids: [state.user.uid]
    }
    commit('enqueueAsync');
    (async () => {
      const ref = db.doc('pages/' + page.id)
      await transaction(ref, page)
      const doc = await ref.get()
      commit('storePage', doc.data())
      commit('enqueueAddPage', Object.assign({role: 1}, doc.data()))
      commit('enqueueRoute', {
        method: 'replace',
        name: 'page-editor',
        params: {pageId: page.id}
      })
    })()
      .catch(error => {
        commit('disablePageCreate', true)
        commit('enqueueError', {error})
      })
      .finally(() => commit('dequeueAsync'))
  },

  deletePage ({commit, state}, page) {
    const pages = [...state.user.pages]
    pages.splice(indexOf(pages, 'id', page.id), 1)
    const items = page.items.map(item => {
      item.images = []
      return item
    });
    (async () => {
      commit('enqueueAsync')
      await db.doc('pages/' + page.id).update({
        items: items,
        images: [],
        deleted: fb.firestore.FieldValue.serverTimestamp()
      })
      await db.doc('users/' + state.user.uid).update({
        pages,
        modified: fb.firestore.FieldValue.serverTimestamp()
      })
      commit('removeCache', ['pages', page.id])
      commit('storeUser', {...state.user, pages})
      commit('enqueueRoute', {name: 'user', params: {uid: state.user.uid}})
      console.log('delete pages/' + page.id)
      alert(page.id + 'を削除しました。')
    })()
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  updatePage: ({commit, state}, page) => {
    for (let i = 0; i < page.images.length; i++) {
      const image = page.images[i]
      if (image.source) {
        const path = 'pages/' + page.id + '/' + page.id + '-' + image.id + '.jpg'
        commit('storeCacheImage', {fullPath: path, source: image.source})
        uploadStorage(
          {full_path: path, source: image.source},
          {customMetadata: {id: page.id, uid: state.user.uid}}
        )
        page.images.splice(i, 1, {
          id: image.id,
          full_path: path
        })
      }
    }
    page = {...state.page, ...page}
    page.modified = fb.firestore.FieldValue.serverTimestamp()
    delete page.items_counter
    delete page.images_counter
    commit('enqueueAsync')
    db.doc('pages/' + page.id).update(page)
      .then(() => {
        console.log('Updated pages/' + page.id)
        commit('storePage', page)
      })
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  updatePageItem ({commit, state}, item) {
    item.price.value -= 0
    for (let i = 0; i < item.images.length; i++) {
      const image = item.images[i]
      if (image.source) {
        const path = `pages/${state.page.id}/${state.page.id}-${image.id}.jpg`
        uploadStorage(
          {full_path: path, source: image.source},
          {
            customMetadata: {pageId: state.page.id, itemId: item.id, uid: state.user.uid}
          }
        )
        commit('storeCacheImage', {fullPath: path, source: image.source})
        item.images.splice(i, 1, {
          id: image.id,
          full_path: path
        })
      }
    }
    const items = [...state.page.items]
    arrayUnion(items, 'id', item)
    sortItems(items)
    commit('enqueueAsync')
    db.doc('pages/' + state.page.id).update({items})
      .then(() => {
        console.log('update pages.items')
        commit('updatePageItems', items)
      })
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  fetchPage ({commit, state}, pageId) {
    let page = null;
    (async () => {
      commit('enqueueAsync')
      if (state.cache.pages[pageId]) {
        page = state.cache.pages[pageId]
        console.log('In cache pages/' + pageId + ' : ' + pageId)
      } else {
        const doc = await db.doc('pages/' + pageId).get()
        if (!doc.exists) {
          throw new Error('pages/' + pageId + ' not found.')
        }
        page = doc.data()
        console.log('Fetched pages/' + pageId)
      }
      commit('storePage', page)
      commit('enqueueHistories', page)
      commit('initializeWishlist')
      if (state.user.uid) {
        const wishlists = state.user.wishlists || []
        const index = indexOf(wishlists, 'page_id', pageId)
        if (index !== false) {
          const wishlist = wishlists[index]
          /**
           * cacheを使わない。会計したことを検出出来ないため都度読み込む
          if (state.cache.wishlists[wishlist.id]) {
            commit('storeWishlist', state.cache.wishlists[wishlist.id])
            console.log('In cache wishlists/' + wishlist.id)
            return false
          }
          */
          // wishlsit読み込み
          const querySnapshot = await db.collection('wishlists')
            .where('users_ref', '==', db.doc('users/' + state.user.uid))
            .where('pages_ref', '==', db.doc('pages/' + pageId))
            .get()
          if (querySnapshot.docs.length) {
            commit('storeWishlist', {
              ...querySnapshot.docs[0].data(),
              id: querySnapshot.docs[0].id
            })
          } else {
            throw new Error('wishlist not found.')
          }
          // user.wishlistsと差分チェック。差分があったら更新
          const after = {
            id: wishlist.id,
            dates: page.dates,
            page_id: page.id,
            images: page.images,
            pages_ref: db.doc('pages/' + page.id),
            title: page.title
          }
          const before = arrayUnion(wishlists, 'id', after)[0]
          after.created = before.created
          if (!compareObject(
            {dates: after.dates, images: after.images, title: after.title},
            {dates: before.dates, images: before.images, title: before.title}
          )) {
            commit('updateUserWishlists', wishlists)
          }
        }
      }
    })()
      .catch(error => {
        commit('enqueueError', {error})
        const wishlists = state.user.wishlists || []
        // if (!wishlists || !(wishlists.length >= 0)) {
        //  return false
        // }
        // pagesが無い場合
        if (error.message.match('pages') || error.message.match('permissions')) {
          commit('pageNotFound')
          commit('notFound', true)
          if (indexOf(wishlists, 'id', pageId) !== false) {
            wishlists[indexOf(wishlists, 'id', pageId)].deleted = true
            commit('updateUserWishlists', wishlists)
          }
        }
        // wishlistがあるはずなのに無い場合
        if (error.message.match('wishlist')) {
          wishlists.splice(indexOf(wishlists, 'id', pageId), 1)
          commit('updateUserWishlists', wishlists)
        }
      })
      .finally(() => commit('dequeueAsync'))
  },

  fetchWishlist ({commit, state}, wishlistId) {
    // 注文または売り上げを読み込む
    const collection = location.href.match('/sales/') ? 'sales' : 'wishlists'
    if (collection === 'sales' && state.sales[state.page.id].histories[wishlistId]) {
      // commit('storeOrder', state.sales[state.page.id].histories[wishlistId])
      return false
    }
    (async () => {
      commit('enqueueAsync')
      const ref = collection === 'sales'
        ? db.doc('pages/' + state.page.id + '/sales/' + wishlistId)
        : db.doc('wishlists/' + wishlistId)
      const wishlist = await ref.get()
      if (wishlist.exists) {
        commit('storeOrder', wishlist.data())
      } else {
        throw new Error('Not found wishlist')
      }
    })()
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  fetchWishlistOnly ({commit, state}, uid) {
    // ユーザが自分自身のwishlistを読み込む
    commit('enqueueAsync')
    db.collection('wishlists')
      .where('users_ref', '==', db.doc('users/' + uid))
      .where('pages_ref', '==', db.doc('pages/' + state.page.id))
      .get()
      .then(querySnapshot => {
        if (querySnapshot.docs.length) {
          commit('storeWishlist', {
            ...querySnapshot.docs[0].data(),
            id: querySnapshot.docs[0].id
          })
        } else {
          console.log('Not found wishlist')
          commit('initializeWishlist')
        }
      })
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  updateWishlist ({commit, state}, wishlist) {
    // 重複防止のtimeout処理をこっちでしたい
    (async () => {
      const doc = wishlist.id ? await db.doc('wishlists/' + wishlist.id).get() : {}
      if (doc.exists) {
        delete wishlist.created
        wishlist.modified = fb.firestore.FieldValue.serverTimestamp()
        await db.doc('wishlists/' + doc.id).update(wishlist)
      } else {
        wishlist.created = fb.firestore.FieldValue.serverTimestamp()
        if (wishlist.users_ref.id === 'undefined') {
          wishlist.users_ref = db.doc('users/' + state.user.uid)
        }
        const ref = db.collection('wishlists').doc()
        wishlist.id = ref.id
        await ref.set(wishlist)
      }
      commit('storeWishlist', wishlist)

      const page = state.cache.pages[wishlist.pages_ref.id]
      state.user.wishlists = state.user.wishlists || []
      if (indexOf(state.user.wishlists, 'page_id', page.id) === false) {
        state.user.wishlists.push({
          id: wishlist.id,
          wishlists_ref: db.doc('wishlists/' + wishlist.id),
          pages_ref: wishlist.pages_ref,
          page_id: page.id,
          title: page.title,
          images: page.images,
          dates: page.dates,
          created: new Date()
        })
        commit('updateUserWishlists', state.user.wishlists)
      }
    })()
      .catch(error => commit('enqueueError', {error}))
  },

  deleteWishlist ({commit, state}, wishlist) {
    (async () => {
      await db.doc('wishlists/' + wishlist.id).delete()
      const index = indexOf(state.user.wishlists, 'page_id', wishlist.pages_ref.id)
      if (index !== false) {
        state.user.wishlists.splice(index, 1)
        await wishlist.users_ref.collection('private').doc('1').update({
          wishlists: state.user.wishlists,
          modified: fb.firestore.FieldValue.serverTimestamp()
        })
      }
      commit('storeUser', state.user)
      commit('initializeWishlist')
    })()
      .catch(error => commit('enqueueError', {error}))
  },

  fetchWishlistByUid ({commit, state}, uid) {
    // ショップメンバーが来店者のウィッシュリストを読み込む
    commit('enqueueAsync')
    db.collection('wishlists')
      .where('users_ref', '==', db.doc('users/' + uid))
      .where('pages_ref', '==', db.doc('pages/' + state.page.id))
      .get()
      .then(querySnapshot => {
        if (querySnapshot.docs.length) {
          commit('storeOrder', querySnapshot.docs[0].data())
          commit('enqueueRoute', {
            method: 'replace',
            name: 'order',
            params: {wishlistId: querySnapshot.docs[0].id}
          })
        } else {
          throw new Error('Not found wishlist')
        }
      })
      .catch(error => {
        commit('enqueueError', {error})
        alert('ウィッシュリストが見つかりませんでした。')
        commit('enqueueRoute', {name: 'page', params: {pageId: state.page.id}})
      })
      .finally(() => commit('dequeueAsync'))
  },

  fetchWishlistWithPage ({commit, state}, wishlistId) {
    // wishlistの情報からpageを読み込む
    (async () => {
      commit('enqueueAsync')
      const ref = location.href.match('/sales/')
        ? db.doc('pages/' + state.page.id + '/sales/' + wishlistId)
        : db.doc('wishlists/' + wishlistId)
      const wishlist = await ref.get()
      if (wishlist.exists) {
        commit('storeOrder', wishlist.data())
      } else {
        throw new Error('Not found wishlist')
      }
      const page = await wishlist.data().pages_ref.get()
      if (page.exists) {
        commit('storePage', page.data())
        commit('enqueueHistories', page.data())
      } else {
        throw new Error('Not found pages/' + wishlist.data().pages_ref.id)
      }
    })()
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  fetchReceipt ({commit, state}, receiptId) {
    ;(async () => {
      commit('enqueueAsync')
      const ref = db.doc('users/' + state.user.uid + '/receipts/' + receiptId)
      const receipt = await ref.get()
      if (receipt.exists) {
        commit('storeReceipt', receipt.data())
      } else {
        throw new Error('Not found receipt')
      }
    })()
      .catch(error => {
        commit('enqueueError', {error})
        commit('pageNotFound')
        commit('notFound', true)
      })
      .finally(() => commit('dequeueAsync'))
  },

  deletePageItem ({commit, state}, itemId) {
    state.page.items.splice(indexOf(state.page.items, 'id', itemId), 1)
    commit('enqueueAsync')
    db.doc('pages/' + state.page.id).update({
      items: state.page.items
    })
      .then(doc => {
        commit('updatePageItems', state.page.items)
        commit('enqueueRoute', {method: 'replace', name: 'page'})
      })
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  fetchMembers ({commit}, members) {
    (async () => {
      commit('enqueueAsync')
      const _members = []
      for (var i in members) {
        const a = await members[i].users_ref.get()
        _members.push(a.data())
      }
      commit('storeMembers', _members)
    })()
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  updateUserHistories ({commit, state}) {
    if (!state.historiesQueue.length) {
      return false
    }
    const history = state.historiesQueue[0]
    commit('dequeueHistories')
    const histories = state.user.histories || []
    arrayUnion(histories, 'id', history)
    histories.sort((a, b) => {
      if (a.created.seconds) {
        a.created = a.created.toDate()
      }
      if (b.created.seconds) {
        b.created = b.created.toDate()
      }
      return a.created < b.created ? 1 : -1
    })
    if (histories.length > 100) {
      histories.shift()
    }
    db.doc('users/' + state.user.uid + '/private/1').update({
      histories: histories
    })
      .then(() => commit('storeUserHistories', histories))
      .catch(error => commit('enqueueError', {error}))
  },

  removeUserHistory ({commit, state}, pageId) {
    const index = indexOf(state.user.histories, 'id', pageId)
    if (index === false) {
      return false
    }
    const histories = state.user.histories
    histories.splice(index, 1)
    db.doc('users/' + state.user.uid + '/private/1').update({
      histories: histories
    })
      .then(() => commit('storeUserHistories', histories))
      .catch(error => commit('enqueueError', {error}))
  },

  fetchSalesList ({commit, state}, params) {
    const created = params[2] || (state.sales[params[0]].current || {}).created || new Date()
    const recent = (state.sales[params[0]].recent || {}).created
    let where = null
    if (params[2] && recent) {
      where = db.collection('pages/' + params[0] + '/sales/').where('created', '>', recent)
    } else {
      where = db.collection('pages/' + params[0] + '/sales/').where('created', '<', created)
    }
    commit('enqueueAsync')
    where.orderBy('created', 'desc').limit(params[1]).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          commit('storeSales', {
            pageId: params[0],
            history: {id: doc.id, ...doc.data()}
          })
        })
      })
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  completeOrder ({commit, state}, order) {
    if (state.page.id !== order.pages_ref.id || !state.user.uid) {
      commit('enqueueError', {error: 'error'})
      return false
    }
    const items = order.items.map(item => {
      const i = indexOf(state.page.items, 'id', item.id)
      if (i === false) {
        item.price.value = 0
        item.quantity = 0
      } else {
        item.price.value = state.page.items[i].price.value
        item.name = state.page.items[i].name
        item.images = state.page.items[i].images
      }
      return item
    })
    const sales = {
      pages_ref: order.pages_ref,
      wishlists_ref: db.doc('wishlists/' + order.id),
      users_ref: db.doc('users/' + state.user.uid),
      items: items,
      created: fb.firestore.FieldValue.serverTimestamp()
    }
    commit('enqueueAsync')
    db.collection('pages/' + order.pages_ref.id + '/sales/').add(sales)
      .then(() => {
        alert('お会計が登録されました。')
        commit('enqueueRoute', {
          name: 'page',
          params: {pageId: order.pages_ref.id}
        })
      })
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  },

  fetchReceipts ({commit, state}) {
    const last = state.user.receipts.length ? state.user.receipts.reduce((a, b) => {
      const aCreated = a.created.seconds ? a.created.toDate() : a.created
      const bCreated = b.created.seconds ? b.created.toDate() : b.created
      return aCreated > bCreated ? a : b
    }).created : new Date(0)
    ;(async () => {
      const querySnapshot = await db.collection('users/' + state.user.uid + '/receipts/')
        .where('created', '>', last)
        .get()
      if (!querySnapshot.docs.length) {
        return []
      }
      return querySnapshot.docs.map(item => item.data())
    })()
      .then(results => {
        if (results.length) {
          commit('storeReceipts', results)
          console.log('Find ' + results.length + ' new receipts')
        }
      })
      .catch(error => commit('enqueueError', {error}))
  },

  createTransfer ({commit}, uids) {
    commit('enqueueAsync')
    const ref = db.doc('users/' + uids[0] + '/transfers/' + uids[1])
    ref.set({created: fb.firestore.FieldValue.serverTimestamp()})
      .then(() => delete localStorage.uid)
      .catch(error => commit('enqueueError', {error}))
      .finally(() => commit('dequeueAsync'))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js